import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-whatsapp-options',
  templateUrl: './whatsapp-options.component.html',
  styleUrls: ['./whatsapp-options.component.css']
})
export class WhatsappOptionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
